export default __webpack_public_path__ + "static/media/diego.7c677c72.jpg";